<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-checkbox
            :error-messages="error"
            v-model="isChecked"
            :hint="translation(translationList.info_valid_from, 'Ca urmare a opțiunii de renunțare la consultanță, te informăm că XIGA nu va evalua in ce masură contractul de asigurare corespunde cerințelor și necesitaților tale. Te rugăm să completezi corect datele ce îți vor fi solicitate in vederea încheierii asigurării.')
" persistent-hint
        >
          <template #label>
            <div>
              {{ translation(translationList.rca_consultancy_agreement, 'Sunt de acord cu renunțarea la consultanță') }}
            </div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, type PropType} from 'vue';
import {useTranslationStore, translation} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'RcaConsultancyWaiver',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    },
  },
  setup(props, {emit}) {
    const isChecked = ref(props.modelValue);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref([]);

    watch(isChecked, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      isChecked.value = newValue;
      error.value = [];
      const isValid = isChecked.value;
      emit('validation-rca-status', {field: 'consultancy_waiver', isValid});
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate event
      window.addEventListener('validate-rca', (data) => {
        if (data.detail && data.detail === 'consultancy_waiver') {
          if (!isChecked.value) {
            error.value = [translation(translationList.value.required_rca_consultancy, 'Te rugăm să accepți renunțarea la consultanță')];
          } else {
            error.value = [];
            emit('validation-rca-status', {field: 'consultancy_waiver', isValid: true});
          }
        }
      });
    });

    return {
      isChecked,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>
